var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.generateClasses()},[_c('div',{class:_vm.isWithoutBody
                ? ''
                : 'uk-card-body' +
                  (_vm.isDark ? ' dark' : '') +
                  (_vm.bodyClass ? ' ' + _vm.bodyClass : '')},[(_vm.title && _vm.title.length > 0)?_c('div',{class:'title' +
                (_vm.isDark ? ' dark' : '') +
                (_vm.isCentered ? ' uk-text-center' : '')},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.info)?_c('Icon',{attrs:{"uk-tooltip":'title:' + _vm.info,"icon":"info"}}):_vm._e()],1):_vm._e(),_vm._t("default")],2),(_vm.$slots.labels)?_c('div',[_vm._t("labels")],2):_vm._e(),(_vm.$slots.footer)?_c('div',{class:'uk-card-footer ' + _vm.footerClass},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }